module.exports = __webpack_public_path__ + "img/section3-index.5ff164ab.png";